import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ChevronRightMini({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M5.27783 2.69531L10.8334 8.25087L5.27783 13.8064"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
